module.exports = __webpack_public_path__ + "media/images/dash-732364b4db94d38a894abf16412429b0336228409c3b5780c78f07f1e1d8f703.svg";